var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnScreenshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88889 1H1.77778C1.34822 1 1 1.34822 1 1.77778V4.88889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88889 15H1.77778C1.34822 15 1 14.6518 1 14.2222V11.1111",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1113 15H14.2224C14.652 15 15.0002 14.6518 15.0002 14.2222V11.1111",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1113 1H14.2224C14.652 1 15.0002 1.34822 15.0002 1.77778V4.88889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1113 4.11108H4.88911C4.45955 4.11108 4.11133 4.45931 4.11133 4.88886V11.1111C4.11133 11.5406 4.45955 11.8889 4.88911 11.8889H11.1113C11.5409 11.8889 11.8891 11.5406 11.8891 11.1111V4.88886C11.8891 4.45931 11.5409 4.11108 11.1113 4.11108Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnScreenshot);
export default __webpack_public_path__ + "static/media/icn-screenshot.3ac9b24e67487859a711b311a12ca76c.svg";
export { ForwardRef as ReactComponent };